import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "浏览内容",
    links: [
      { label: "对比榜单", to: "/bang" },
      { label: "美妆护肤", to: "/bang?cat=beauty" },
      { label: "穿搭时尚", to: "/bang?cat=fashion" },
      { label: "知识科普", to: "/bang?cat=knowledge" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about" },
      { label: "联系反馈", to: "/contact" },
      { label: "线索提交", to: "/contact" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-16 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr]">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
              <i className="ri-article-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">反差档案</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-secondary-200">
            把同一位创作者不同阶段的公开形象整理成组，方便你一次性看清风格是怎么一步步长出来的。
          </p>
          <p className="mt-4 text-xs leading-relaxed text-secondary-300">
            本站内容均为公开信息整理，仅作风格变化记录与娱乐参考，不构成对任何个人的评价。
          </p>
        </div>

        {footerColumns.map((column) => (
          <nav key={column.title} aria-label={column.title}>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/about" className="cursor-pointer hover:text-accent-300">
                {column.title}
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-3">
              {column.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <Link to="/contact" className="cursor-pointer hover:text-accent-300">
              联系与反馈
            </Link>
          </h4>
          <ul className="mt-4 flex flex-col gap-3 text-sm text-secondary-200">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-base text-accent-400"></i>
              <span>hello@fancha-archive.example</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-base text-accent-400"></i>
              <span>每个工作日 10:00 - 18:00 回复</span>
            </li>
          </ul>
          <Link
            to="/contact"
            className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-secondary-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-send-plane-line"></i>
            提交你的线索
          </Link>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-3 px-4 py-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p>反差档案 · 网红形象变化观察站</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容均为公开信息整理</span>
            <span className="hidden sm:inline">·</span>
            <span>如认为内容有误，欢迎联系更正</span>
          </p>
        </div>
      </div>
    </footer>
  );
}